import CloseIcon from '@mui/icons-material/Close';
import type { Theme } from '@mui/material';
import { IconButton, styled } from '@mui/material';
import type {
  SnackbarAction,
  SnackbarOrigin,
  SnackbarProviderProps as NotistackSnackbarProviderProps,
} from 'notistack';
import {
  SnackbarProvider as NotistackSnackbarProvider,
  useSnackbar,
} from 'notistack';

export interface SnackbarProviderProps extends NotistackSnackbarProviderProps {}

const CloseSnackbarButton: SnackbarAction = (key) => {
  const { closeSnackbar } = useSnackbar();
  return (
    <IconButton onClick={() => closeSnackbar(key)} size="small">
      <CloseIcon />
    </IconButton>
  );
};

export const SnackbarProvider = styled(
  ({ children, ...props }: SnackbarProviderProps) => {
    const anchorOrigin: SnackbarOrigin = {
      horizontal: 'right',
      vertical: 'top',
    };

    return (
      <NotistackSnackbarProvider
        action={CloseSnackbarButton}
        anchorOrigin={anchorOrigin}
        {...props}
      >
        {children}
      </NotistackSnackbarProvider>
    );
  },
)(({ theme }: { theme: Theme }) => ({
  '&.SnackbarItem-variantSuccess': {
    backgroundColor: `${theme.palette.success.dark}`,
  },

  '&.SnackbarItem-variantError': {
    backgroundColor: `${theme.palette.error.main}`,
  },

  '&.SnackbarItem-variantInfo': {
    backgroundColor: `${theme.colors.neutral[500]}`,
  },

  '&.SnackbarItem-variantWarning': {
    backgroundColor: `${theme.colors.secondary[400]}`,
  },
}));

export default SnackbarProvider;
